import styled from 'styled-components'
import { Marker } from 'react-map-gl'
// import { BREAK_POINT_MD } from '@CSSVars/variables'

export const _ActiveMarker = styled(Marker)`
  pointer-events: none;
  z-index: 1;
  * {
    pointer-events: auto;
  }
`

export const _MarkerContent = styled.div`
`

export const _Label = styled.span`
  position: absolute;
  font-size: 14px;
  line-height: 22px;
  width: 140px;
  top: 50%;
  //transform: translate(0, -50%);
  margin-left: 32px;
`
